import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { setHelp } from "../../actions/ui/marketplace";
import Help from "../helper/help";
import Modal from "../helper/modal";
import M from "materialize-css/dist/js/materialize.min.js";
import { tutorialData } from "./tutorialData";
// import Image from "./image";

class SetHelp extends Component {
  constructor() {
    super();
    this.state = {
      oldHeight: "SYNCING",
      num: 0,
      section: "Navigation Bar",
      index: 0
    };
  }
  setHelp() {
    // this.props.setHelp(!this.props.helpMode,()=>{});
    var instance = M.Modal.getInstance(
      document.querySelectorAll("#modalHelp")[0]
    );
    instance.open();
  }
  closeModal() {
    var instance = M.Modal.getInstance(
      document.querySelectorAll("#modalHelp")[0]
    );
    instance.close();
  }
  nextImage() {
    this.setState({ num: this.state.num + 1 });
  }
  prevImage() {
    this.setState({ num: this.state.num - 1 });
  }
  setTutorial({ section, index }) {
    this.setState({ section, index });
  }
  renderModal() {
    let imageSrc = `./${this.state.section.replace(" - ", "").replace(" ", "")}${this.state.index}.png`;
    let component = (
      <div className="row">
        <div
          className="col s3 center"
          style={{
            maxHeight: "640px",
            overflowY: "scroll",
            borderRight: "1px solid grey"
          }}
        >
          {Object.keys(tutorialData).map(section => (
            <div
              key={section}
              className="col s12 center"
              style={{ marginBottom: "10px" }}
            >
              <p
                style={{ opacity: this.state.section == section ? 1 : 0.6 }}
                className="tutorialSection"
              >
                {section}
              </p>
              {tutorialData[section].map(({ title }, index) => (
                <p
                  key={index}
                  style={{
                    opacity:
                      this.state.section == section && this.state.index == index
                        ? 1
                        : 0.5,
                    background:
                      this.state.section == section && this.state.index == index
                        ? "black"
                        : "",
                    color:
                      this.state.section == section && this.state.index == index
                        ? "white"
                        : "black"
                  }}
                  className="tutorialSection2"
                  onClick={this.setTutorial.bind(this, { section, index })}
                >
                  {title}
                </p>
              ))}
            </div>
          ))}
        </div>
        <div className="col s9 center" style={{}}>
          <div className="col s12 center" style={{}}>
            <h3 className="tutorialTitle">
              {tutorialData[this.state.section][this.state.index].title}
            </h3>
            <img src={imageSrc} style={{ width: "100%", height: "100%" }} />
          </div>
          <div className="col s12 left" style={{ borderTop: "1px solid grey" }}>
            <p className="numImage">
              {" "}
              {
                tutorialData[this.state.section][this.state.index].description
              }{" "}
            </p>
          </div>
        </div>
      </div>
    );
    return (
      <Modal
        style={{ width: "60%" }}
        id="modalHelp"
        noClose={true}
        classes="modal modalOrders black-text"
        title="Tutorial"
        component={component}
        logout={false}
      />
    );
  }
  render() {
    return (
      <li>
        <Link
          to="#"
          onClick={this.setHelp.bind(this)}
          className="white-text rightLink"
        >
          tutorial
        </Link>
        {this.renderModal()}
      </li>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    helpMode: state.ui_marketplace.helpMode
  };
}

//
export default connect(
  mapStateToProps,
  { setHelp }
)(SetHelp);
